// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2E2gl","list":"PatternAutocomplete_list__2qQ7q"};